import { render, staticRenderFns } from "./DatosCliente.vue?vue&type=template&id=44b6bcbf&scoped=true&"
import script from "./DatosCliente.vue?vue&type=script&lang=js&"
export * from "./DatosCliente.vue?vue&type=script&lang=js&"
import style0 from "./DatosCliente.vue?vue&type=style&index=0&id=44b6bcbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b6bcbf",
  null
  
)

export default component.exports